var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mainLayout'),_c('checkAcces',{attrs:{"pageAccess":"admin"}}),_c('div',{staticClass:"contentAdmin mainContent"},[_c('leftMenu',{staticClass:"leftMenu"}),_c('CasTable',{staticClass:"casTable",attrs:{"global":false}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }